import moment from 'moment';
import { I18n } from 'react-redux-i18n';

export default value => moment(value).format(I18n.t('application.date.short'));



// WEBPACK FOOTER //
// ./src/components/normalize/DateNormalize.js